import { type PaymentKeyHash } from '@lucid-evolution/lucid';
import 'reflect-metadata';
import { CS, Convertible, Maybe, StakeCredentialPubKeyHash, asSmartDBEntity } from '../Commons';
import { BaseSmartDBEntity, SmartUTxOEntity } from './index.exports';

@asSmartDBEntity()
export class ScriptEntity extends BaseSmartDBEntity {
    protected static _apiRoute: string = 'scripts';
    protected static _className: string = 'Script';
    // protected static _mongoTableName: string = 'Script';

    protected static _plutusDataIndex = 0;
    protected static _is_NET_id_Unique = false;

    // #region fields

    // sobre escribo este campo del base smart db, por que alli no se carga y para el fondo es necesario cargarlo para ver si el fondo esta deployado o no
    @Convertible({ type: String, propertyToFill: 'smartUTxO', relation: 'OneToOne', typeRelation: SmartUTxOEntity, cascadeSave: true, cascadeLoad: true })
    smartUTxO_id!: string | undefined;

    @Convertible({ isCreatedAt: true })
    createdAt!: Date;

    @Convertible({ isUpdatedAt: true })
    updatedAt!: Date;

    // #endregion fields

    // #region datum

    @Convertible({ isForDatum: true })
    sdVersion!: number;

    @Convertible({ isForDatum: true, type: Maybe<CS> })
    sdFundPolicy_CS!: Maybe<CS>;

    @Convertible({ isForDatum: true, type: String })
    sdAdminPaymentPKH!: PaymentKeyHash;

    @Convertible({ isForDatum: true, type: Maybe<StakeCredentialPubKeyHash> })
    sdAdminStakePKH!: Maybe<StakeCredentialPubKeyHash>;

    @Convertible({ isForDatum: true })
    sdScriptHash!: string;

    // #endregion datum

    // #region  db

    public static defaultFieldsWhenUndefined: Record<string, boolean> = {};

    // HACK: puse todos los campos para evitar erroress
    public static alwaysFieldsForSelect: Record<string, boolean> = {
        ...super.alwaysFieldsForSelect,
        sdVersion: true,
        sdFundPolicy_CS: true,
        sdAdminPaymentPKH: true,
        sdAdminStakePKH: true,
        sdScriptHash: true,
    };

    // #endregion  db

    // #region class methods

    public getNET_id_TN_Str(): string {
        return this.sdScriptHash;
    }

    // #endregion class methods
}
